module.exports = __webpack_public_path__ + "static/img/dia-bg.7e7b178c.png";